import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get, post } from "sr/utils/axios";

export const getBackgroundCheckStatus = async (cleanerId) => {
  try {
    return await get<ApiResponse<[]>>(`/checkr/status/${cleanerId}`).then((res) => {
      return res;
    });
  } catch (e) {
    HandleApiError(e);
  }
};
